import { useQuery } from '@tanstack/react-query';
import { getPendingListSortShares } from '../../../api/ListSort/getPendingListSortShares';

export function useGetPendingListSortShares() {
  const getQuery = useQuery({
    queryKey: [ 'get-pending-list-sort-shares' ],
    queryFn: () => getPendingListSortShares()
  });

  if (getQuery.isError) {
    console.error('There was an error in useGetPendingListSortShares ', getQuery);
  }

  return {
    data: getQuery.data?.data?.shares || null,
    dismissed: Boolean(getQuery.data?.data?.dismissed),
    error: getQuery.error || null,
    isLoading: getQuery.isLoading,
    isPending: getQuery.isPending,
    refetch: getQuery.refetch
  };
}
